export default {}



// WEBPACK FOOTER //
// ./src/store/models/itemimage.js